import cn from 'classnames';

import * as Icons from '@/primitives/Icons';

import styles from './InfoMessage.module.css';

type Variant = 'default' | 'ai' | 'error' | 'success' | 'warning';

const variantsMap: Record<Variant, string> = {
  default: cn(styles.gray),
  ai: cn(styles.blue, styles.rounded, styles.snug),
  error: cn(styles.red, styles.rounded, styles.snug),
  success: cn(styles.green, styles.rounded, styles.snug),
  warning: cn(styles.warning, styles.rounded, styles.snug),
};

const iconMap: Record<Variant, React.ReactNode> = {
  default: <Icons.Info />,
  ai: <Icons.Sparkles />,
  error: <Icons.CircledX />,
  success: <Icons.Checkmark />,
  warning: <Icons.WarningTriangle />,
};

const colorMap: Record<Variant, string | undefined> = {
  default: undefined,
  ai: 'var(--blue-5)',
  error: 'var(--red-4)',
  success: 'var(--green-4)',
  warning: 'var(--color-warn)',
};

const sizeMap: Record<Variant, number> = {
  default: 2,
  ai: 2,
  error: 3,
  success: 3,
  warning: 3,
};

export const InfoMessage = ({
  message,
  variant = 'default',
  className,
}: {
  message: string;
  children?: React.ReactNode;
  variant?: Variant;
  className?: string;
}) => {
  return (
    <div className={cn(styles.info, variantsMap[variant], className)}>
      <p className="flexAlign gap-xs">
        <Icons.Icon
          icon={iconMap[variant]}
          className="noShrink"
          color={colorMap[variant]}
          size={sizeMap[variant]}
        />
        {message}
      </p>
    </div>
  );
};
